import React from 'react';
// import { Home } from 'reportFragments'

export const HomePage = () => {
    return <React.Fragment>{/*<Home/>*/}</React.Fragment>;
};
